/**
 * @param {number} clientY
 * @param {HTMLElement[]} rowElements
 * @param {number} itemCount
 * @returns {number}
 */
export const getDropIndexFromPointer = (clientY, rowElements, itemCount) => {
  if (!rowElements.length) {
    return 0;
  }

  const lastRect = rowElements[rowElements.length - 1].getBoundingClientRect();
  if (clientY >= lastRect.bottom) {
    return itemCount;
  }

  for (let index = 0; index < rowElements.length; index += 1) {
    const rect = rowElements[index].getBoundingClientRect();
    const midpoint = rect.top + rect.height / 2;

    if (clientY < midpoint) {
      return index;
    }
  }

  return itemCount;
};

/**
 * Convert a visual "insert before this row" index into a splice insert index.
 * @param {number} fromIndex
 * @param {number} insertBeforeIndex
 * @param {number} itemCount
 * @returns {number}
 */
export const toSpliceInsertIndex = (
  fromIndex,
  insertBeforeIndex,
  itemCount
) => {
  if (insertBeforeIndex >= itemCount) {
    return itemCount;
  }

  if (fromIndex < insertBeforeIndex) {
    return insertBeforeIndex - 1;
  }

  return insertBeforeIndex;
};

/**
 * Returns true when a splice reorder would change visible item order.
 * @param {number} fromIndex
 * @param {number} toIndex
 * @param {number} itemCount
 * @returns {boolean}
 */
export const wouldReorderChangeOrder = (fromIndex, toIndex, itemCount) => {
  if (fromIndex === toIndex) {
    return false;
  }

  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= itemCount ||
    toIndex > itemCount
  ) {
    return false;
  }

  const order = Array.from({ length: itemCount }, (_, index) => index);
  const [moved] = order.splice(fromIndex, 1);
  order.splice(toIndex, 0, moved);

  return order.some((value, index) => value !== index);
};
